var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1008.439986 837.569172c0 31.027137-12.411629 74.466869-68.26299 74.466869-37.231016 0-819.126855 0-856.35787 0-55.851361 0-68.25912-43.439733-68.25912-74.466869 0-105.494006 93.082377-254.423874 260.627754-254.423874 0 0 49.647482 80.670749 235.812237 80.670749s235.808366-80.670749 235.808366-80.670749C915.357609 583.145297 1008.439986 732.075166 1008.439986 837.569172zM517.460803-1.0e-06c-143.812539 0-260.394576 130.324036-260.394576 291.086943s116.582037 291.086943 260.394576 291.086943 260.394576-130.324036 260.394576-291.086943S661.273342-1.0e-06 517.460803-1.0e-06z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember);
export default __webpack_public_path__ + "static/media/member.54dbcc86d4e1a8e51d92d5e0305fc4aa.svg";
export { ForwardRef as ReactComponent };